import { Major } from '../builders/major_builder';
import { CIPProgramArea } from '../builders/cip_program_area_builder';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';
import { ITransferCIPProgramAreasDatasource } from '../datasources/transfer_cip_program_areas_datasource';

export interface ITransferMajorsCategorizedQueryResult {
  category: string;
  majors: Major[];
}

export class TransferMajorsCategorizedQuery implements IQuery {
  private _result: ITransferMajorsCategorizedQueryResult[];

  constructor(
    QueryMediator: IQueryMediator,
    private ngTransferMajorsDatasource: ITransferMajorsDatasource,
    private ngTransferCIPProgramAreasDatasource: ITransferCIPProgramAreasDatasource
  ) {
    QueryMediator.registerQuery(this, ngTransferMajorsDatasource);
  }

  run(): TransferMajorsCategorizedQuery {
    const cipProgramAreas = this.ngTransferCIPProgramAreasDatasource.values();

    const allMajors = this.ngTransferMajorsDatasource.values();
    const allMajorsWithCategory = allMajors
      .map((major) => ({
        ...major,
        category: _(cipProgramAreas).find(
          (cipProgramArea: CIPProgramArea) => cipProgramArea.nk === major.cip_code.toString().substring(0, 2)
        )
      }))
      .filter((major) => major.category !== undefined)
      .map((major) => ({
        ...major,
        category: major.category.title
      }));

    this._result = _(allMajorsWithCategory)
      .sortBy('displayTitle')
      .groupBy('category')
      .sortBy((category: Major[], name: string): string => name)
      .map((majors: Major[]) => {
        return {
          category: _.first(majors).category,
          majors
        };
      })
      .value();

    return this;
  }

  get result(): ITransferMajorsCategorizedQueryResult[] {
    return this._result;
  }
}

angular.module('capability-ng-transfer').service('ngTransferMajorsCategorizedQuery', TransferMajorsCategorizedQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_majors_categorized_query.ts